import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Login } from './login';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CryptoService } from '../../shared/crypto/crypto.service';

@Injectable()
export class LoginService {
  token: string | null;
  isloggedIn: boolean = false;
  rememberMe: boolean = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    private cryptoService: CryptoService,
  ) {
    let currentUser: any = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.token = currentUser && currentUser.token;
  }

  login(login: Login): Observable<boolean> {
    let that = this;
    let url = "token";
    let body = "username=" + login.UserName + "&password=" + encodeURIComponent(login.Password) + "&grant_type=password" + "&Scope=" + (login.Code ? login.Code: "") + "&rememberMe=" + login.RememberMe;
    return this.http
      .post(url, body)
      .map((response: any) => {
        if (response.verification_code) {
          that.toastr.success(response.verification_code, "");
          localStorage.setItem('code', JSON.stringify({
            username: response.userName,
            codeSent: true,
          }));
          return false;
        }
        let token = response && response.access_token;
        if (token) {
          localStorage.removeItem('storeMenu');
          this.token = token;
          this.isloggedIn = true;
          if (login.RememberMe === true) {
            this.resetcredentials();
            localStorage.setItem("rememberUser", JSON.stringify({
              username: response.userName,
              password: this.cryptoService.encryptString(login.Password)
            }))
            localStorage.setItem('rememberCurrentUser', 'true');
          }else{
            localStorage.setItem('rememberCurrentUser', 'false');
          }
          localStorage.setItem('currentUser', JSON.stringify({
            username: response.userName,
            password: this.cryptoService.encryptString(login.Password),
            token: token,
            tokenLife: response.expires_in / 3600,
            tokenTime: new Date().getTime(),
            isReadonly: response.isReadonly
          }));
          return true;
        }
        else {
          return false;
        }
      })
      .catch((error: any) => {
        return throwError(error);
      });
  }

  resetcredentials() {
    localStorage.removeItem('rememberCurrentUser');
    localStorage.removeItem('rememberUser');
  }

  logout(): void {
    this.signOut()
      .subscribe((res: any) => {
        this.reset();
        this.router.navigate(['auth/login']);
      });
  }

  signOut() {
    localStorage.removeItem('storeMenu');
    return this.http.get("Account/Signout")
      .map((res: any) => res);
  }

  private _listners = new Subject<any>();

  listen(): Observable<any> {
    return this._listners.asObservable();
  }

  filter(filterBy: string) {
    this._listners.next(filterBy);
  }

  reset(): void {
    this.token = null;
    this.isloggedIn = false;
    localStorage.removeItem('currentUser');
  }
}
